module.exports = __webpack_public_path__ + "dashboard/img/edit.dec291983c49542ea8d87d32b962b3b7.svg";